import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AddEditDocumentFolderComponent } from './add-edit-document-folder.component';

@NgModule({
  declarations: [AddEditDocumentFolderComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [AddEditDocumentFolderComponent],
  entryComponents: [AddEditDocumentFolderComponent]
})
export class AddEditDocumentFolderModule { }
